import axios from 'axios'
import Cookies from 'js-cookie'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

const state = {
  generatedFighter: null,
  userData: null
}

const mutations = {
  SET_GENERATED_FIGHTER(state, fighter) {
    state.generatedFighter = fighter
  },
  SET_USER_DATA(state, data) {
    state.userData = data
  }
}

const actions = {
  async generateFighter({ commit, rootState, dispatch }) {
    try {
      // Ensure player data is loaded
      console.log('rootState.player.playerData:', rootState.player.playerData)
      if (!rootState.player.playerData) {
        await dispatch('player/loadPlayerData', null, { root: true })
      }

      // Verify player exists and has data
      if (!rootState.player.playerData?.id) {
        throw new Error('Player not found')
      }

      const response = await api.post('/api/fighters/generate', {
        playerId: rootState.player.playerData.id
      }, {
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      })
      
      if (response.data?.fighter) {
        await dispatch('player/loadPlayerData', null, { root: true }) // Refresh player data
        commit('SET_GENERATED_FIGHTER', response.data.fighter)
        return response.data.fighter
      } else {
        throw new Error('Invalid fighter data received')
      }
    } catch (error) {
      console.error('Generate fighter error:', error)
      const errorMessage = error.response?.data?.error?.message || error.message || 'Failed to generate fighter'
      throw new Error(errorMessage)
    }
  },

  async hireFighter({ commit, dispatch, rootState }, fighterData) {
    try {
      // Ensure we have player data
      if (!rootState.player.playerData?.id) {
        throw new Error('Player data not found')
      }

      const response = await api.post('/api/fighters/hire', {
        ...fighterData,
        playerId: rootState.player.playerData.id
      }, {
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      })
      
      if (response.data && response.data.fighter) {
        commit('SET_GENERATED_FIGHTER', null)
        await dispatch('player/loadPlayerData', null, { root: true })
        return response.data.fighter
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Hire fighter error:', error)
      throw new Error(error.response?.data?.error?.message || 'Failed to hire fighter')
    }
  },

  async equipItem(_, { fighterId, itemId }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/fighters/${fighterId}/equip`,
        { itemId },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      return response.data
    } catch (error) {
      console.error('Store: Failed to equip item', error)
      throw error
    }
  },

  async unequipItem(_, { fighterId, equipSlot }) {
    try {
      console.log('Store: Unequipping item from slot:', equipSlot)
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/fighters/${fighterId}/unequip`,
        { equipSlot },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      console.log('Unequip response:', response.data)
      return response.data
    } catch (error) {
      console.error('Store: Failed to unequip item', error.response?.data || error)
      throw error
    }
  },

  async sellFighter({ dispatch, rootState }, { fighterId, price, priceInParalleliums, isAuction, endDate }) {
    try {
      // Check if fighter is dead before allowing sale
      const fighter = rootState.player.playerData.fighters.find(f => f.id === fighterId);
      
      if (!fighter) {
        throw new Error('Lutador não encontrado');
      }
      
      if (fighter.dead) {
        throw new Error('Não é possível vender um lutador falecido');
      }
      
      const response = await api.post('/api/fighter-stores/sell', {
        fighterId,
        price,
        priceInParalleliums,
        isAuction,
        endDate
      }, {
        headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
      })
      
      if (!response.data) {
        throw new Error('Invalid response from server')
      }

      // Add this line to refresh player data
      await dispatch('player/loadPlayerData', null, { root: true });
      
      return response.data
    } catch (error) {
      console.error('Sell fighter error:', error)
      throw new Error(error.response?.data?.error?.message || error.message || 'Failed to sell fighter')
    }
  },

  async loadUserData({ commit }) {
    try {
      const response = await api.get('/api/users/me', {
        headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
      })
      
      if (response.data) {
        commit('SET_USER_DATA', response.data)
        return response.data
      }
    } catch (error) {
      console.error('Error loading user data:', error)
      throw error
    }
  },

  async fireFighter({ dispatch }, fighterId) {
    try {
      const response = await api.delete(`/api/fighters/${fighterId}/fire`, {
        headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
      });

      // Add this line to refresh player data
      await dispatch('player/loadPlayerData', null, { root: true });

      return response.data;
    } catch (error) {
      console.error('Fire fighter error:', error);
      throw new Error(error.response?.data?.error?.message || error.message || 'Failed to fire fighter');
    }
  }
}

const getters = {
  generatedFighter: state => state.generatedFighter,
  getUserData: state => state.userData
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
